@if (showField$ | async) {
  <div class="radio-wrapper">
    @if (field.placeholder) {
      <label id="radio-group-label">{{field.placeholder}}</label>
    }
    <mat-radio-group [ngClass]="field.attrs?.direction === 'vertical' ? 'vertical-group' : 'horizontal-group'" aria-labelledby="radio-group-label"
      [attr.name]="field.name"
      [formControl]="$any(field.control)">
      <!-- TODO: ability to pass in label position and maybe a way to distingish column vs row buttons -->
      @for (o of field.options; track o) {
        <mat-radio-button [value]="o.value" labelPosition="after" [matTooltip]="o.tooltip" [matTooltipPosition]="o.tooltipPosition || 'below'">
          {{o.label}}
        </mat-radio-button>
      }
    </mat-radio-group>
    @if (hasDanger()) {
      <mat-hint [ngStyle]="{'color': 'red'}" fxFlexAlign="start">{{errorText()}}</mat-hint>
    }
    @if (field.help && !hasDanger()) {
      <mat-hint fxFlexAlign="start">{{field.help | translate}}</mat-hint>
    }
  </div>
}

